import { Component, EventEmitter, Input, Output } from '@angular/core'
import { Store } from '@ngrx/store'
import { TranslateService } from '@ngx-translate/core'
import { Observable } from 'rxjs'
import { AppState } from 'src/app/core/core.state'
import { Member } from 'src/app/features/member/member'
import { MenuItem } from 'src/app/menu/menu.model'
import { NavItem } from 'src/app/shared/interfaces'
import { ConfigurationService } from 'src/app/shared/services/configuration.service'
import { AdditionalMenuItem } from 'src/environments/environment-model'

@Component({
  selector: 'primary-navbar-desktop-main-menu-block',
  templateUrl: './show.component.html'
})
export class PrimaryNavBarDesktopMainMenuComponent {
  @Input() member$!: Observable<Member>
  @Input() menuItems$!: Observable<MenuItem[]>
  @Input() additionalMenuItems: AdditionalMenuItem[] = []
  @Input() configurationService: ConfigurationService

  @Output() onLinkClick = new EventEmitter<{
    item: NavItem
    event: MouseEvent
  }>()
  @Output() ticketingReset = new EventEmitter<void>()

  constructor(
    private store: Store<AppState>,
    private translate: TranslateService
  ) {}

  trackByMenuItem(index: number, item: { link?: string }): string {
    return item.link || index.toString()
  }

  handleLinkClick(item: NavItem, event: MouseEvent) {
    this.onLinkClick.emit({ item, event })
  }
}
